<template>
<div>
      <v-flex xs12 sm6 md6 lg6 offset-lg3 offset-sm3 offset-md3 mt-3>
        <!-- Alert -->
        <Alert :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <v-card class="semi-transparent-8-bg v-card__text">
            <!--Form-->
            <v-form ref="form" v-model="valid" lazy-validation class="theme--dark.v-label">
                <Logo style="display: flex; justify-content: center; align-items: center; flex-direction: column;"/>
                <!--Form-name-->
                <v-text-field v-model="fullname" id="register-fullnameField" class="borderlessInput register-fullnameField" single-line box autofocus background-color="#7575757d" :rules="fullnameRules" :label="$t( 'user_management.full_name' )" :hint="$t( 'user_management.full_name_hint' )" required></v-text-field>

                <!--Form-name-->
                <v-text-field v-model="username" id="register-usernameField" class="borderlessInput register-usernameField" single-line box autofocus background-color="#7575757d" :rules="usernameRules" :label="$t( 'user_management.username' )" required></v-text-field>

                <!--Form-password-->
                <v-text-field v-model="password" id="register-passwordField" class="borderlessInput register-passwordField" single-line box autofocus background-color="#7575757d" :rules="passwordRules" :label="$t( 'user_management.password' )" type="password" required></v-text-field>

                <!--Form-password-->
                <v-text-field v-model="confirmPassword" id="register-confirmPasswordField" class="borderlessInput register-confirmPasswordField" single-line box autofocus background-color="#7575757d" :rules="confirmPasswordRules" :label="$t( 'user_management.confirm_pass' )" type="password" required></v-text-field>

                <!--Form phone no-->
                <v-text-field v-model="phone" id="register-phoneNoField" class="borderlessInput register-phoneNoField" single-line box autofocus background-color="#7575757d" :rules="phoneRules" :label="$t( 'user_management.phone_no' )" :hint="$t( 'user_management.phone_number_hint' )" required></v-text-field>

                <div style="display: flex;justify-content: center; flex-direction: column; align-items:center;" class="mt-2 mb-4">
                    <v-btn :disabled="!valid" color="success" @click.prevent="register" style="width:100%;">
                         {{ $t( 'user_management.register' ) }}
                    </v-btn>
                </div>

            </v-form>
        </v-card>
    </v-flex>


</div>
</template>

<script>
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";
import Logo from "@/components/Layout/Logo.vue";

export default {
    name: 'Register',
    data() {
        return {
            valid: true,
            fullname: "",
            username: "",
            password: "",
            confirmPassword: "",
            phone: "",
            // TAC: "",
            // TACRules: [
            //     v => !!v || "TAC is required",
            //     v => (v && v.length <= 5) || "TAC code must be less than 5 characters"
            // ],
            // PIN: "",
            // PINRules: [
            //     v => !!v || "Referral is required",
            //     v => (v && v.length <= 5) || "Referral code (PIN) must be less than 5 characters"
            // ],
            // recommend: false,
            alertType: "",
            message: "",
            visibility: "",
            progressbar: false,
        }
    },
    components: {
        Alert,
        Logo
    },
    mounted: function() {

        $('input[type=text]').focus(function() {

            console.log('focus');

            let targetParentId = null;

            targetParentId = $(this).attr('id');

           focusFormFieldAnimation(targetParentId);

        });

        $('input[type=text]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

        $('input[type=password]').focus(function() {

            let targetParentId = null;

            let targetParentClass = null;

            targetParentId = $(this).attr('id');

            focusFormFieldAnimation(targetParentId);

        });

        $('input[type=password]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

        function focusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        }

        function unfocusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','');

            targetParentClass.css('box-shadow','');

            targetParentClass.css('transition-delay','');
        }
    },
    computed : {
        fullnameRules() {
            return [
                v => !!v || this.$t( 'user_management.full_name_validation_rule' ),
                v => (v && v.length >= 6) || this.$t( 'user_management.full_name_length_validation_rule' )
            ]
        },
        usernameRules() {
            return [
                v => !!v || this.$t( 'user_management.user_name_validation_rule' ),
                v => (v && v.length >= 6) || this.$t( 'user_management.user_length_validation_rule' )
            ]
        },
        passwordRules() {
            return [
                v => !!v || this.$t( 'user_management.password_validation_rule' ),
                v => (v && v.length >= 6) || this.$t( 'user_management.pass_length_validation_rule' )
            ]
        },
        confirmPasswordRules() {
            return [
                v => !!v || this.$t( 'user_management.confirm_pass_validation_rule' ),
                v => this.confirmPasswordCheck()
                // https://stackoverflow.com/questions/47213703/vuetify-form-validation-defining-es6-rules-for-matching-inputs
            ]
        },
        phoneRules() {
            return [
                v => !!v || this.$t( 'user_management.phone_validation_rule' ),
                v => (v && v.length >= 10 && v.length <= 12) || this.$t( 'user_management.phone_length_validation_rule' )
            ]
        }
    },
    methods: {
        resetAlert() {
            this.visibility = false;
            this.message = "";
            this.alertType = "";
            this.progressbar = false;
        },
        async register() {
            if (this.$refs.form.validate()) {
                this.resetAlert();
                this.progressbar = true;
                let res = await Api.postRegister({
                    username: this.username,
                    password: this.password,
                    password_confirmation: this.confirmPassword,
                    fullname: this.fullname,
                    tel_no: this.phone,
                    token: this.$store.getters.browser_identity
                });
                this.progressbar = false;
                if (res && 'success' in res && res.success === true) {
                    this.$store.commit('toggleRegistrationFlag', true);
                    this.$store.dispatch('login', res.data);
                    this.$router.push({
                        name: "home"
                    });
                } else {
                    this.visibility = true;
                    this.message = res.message;
                    for (var oprop in res.data) {
                        this.message += '<br>' + res.data[oprop];
                    }
                    this.alertType = "error";
                }
            }
        },
        // request() {
        //     this.message = "Request successfull";
        //     this.icon = "done_all";
        //     this.color = "green";
        //     this.snackbar = true;
        //     this.ready = true;
        // },
        confirmPasswordCheck() {
            return (this.password === this.confirmPassword) || this.$t( 'user_management.passwords_match_validation_rule' );
        }
    },
}
</script>

<style>

.borderlessInput .v-input__control .v-input__slot:before {
    border-style: none !important;
}
</style>
